import dayjs from "dayjs";
import relativeTimePlugin from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";

dayjs.extend(relativeTimePlugin);
dayjs.locale("zh-cn");

/** 「3 天前」 */
export function relativeTime(iso: string, now = new Date()): string {
  return dayjs(iso).from(dayjs(now));
}

export function formatDateTime(iso: string): string {
  return dayjs(iso).format("YYYY 年 M 月 D 日 HH:mm");
}

export function formatDate(iso: string): string {
  return dayjs(iso).format("YYYY 年 M 月 D 日");
}
